<template>
    <div class="half-block" c>
        <div class="row">
            <div class="col-12">
                <div class="form-group form-group-1">
                    <label for="" class="form-label">{{ title }}</label>
                    <div class="row align-items-center mb-4">
                        <div class="col-6">

                            <date-picker
                                v-model="dateAndTime"
                                type="datetime"
                                placeholder="Select date and time"
                                value-type="format"
                                format="MM-DD-YYYY h:mm a"
                                :show-time-panel="showTimePanel"
                                :default-value="defaultDate"
                                @close="handleOpenChange"
                                @change="sendDataForSaving"

                            >
                                <template v-slot:footer>
                                    <button
                                        class="mx-btn mx-btn-text"
                                        @click="toggleTimePanel"
                                    >
                                        {{ showTimePanel ? 'select date' : 'select time' }}
                                    </button>
                                </template>
                            </date-picker>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'EventDatePicker',
    props: {
        title: String,
        dateString: String,
        part: String
    },
    data() {
        return {
            showTimePanel: false,
            dateAndTime: this.parseTimeForPicker(this.dateString) ?? null,
            defaultDate: new Date().setHours(12, 0),
        }
    },
    methods: {
        toggleTimePanel() {
            this.showTimePanel = !this.showTimePanel;
        },
        handleOpenChange() {
            this.showTimePanel = false;
        },
        sendDataForSaving() {
            this.$emit('data-changed', this.dateAndTime, this.part);
        },
    },
    watch: {
        dateString(newVal) {
            if (newVal) {
                this.dateAndTime = this.parseTimeForPicker(newVal)
            } else {
                this.dateAndTime = null
            }
        },
    }
}


</script>


<style scoped>

</style>
